import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const jupiterOne = defineConnector({
  identifier: "jupiterOne",
  name: "JupiterOne",
  tagLine: "Cyber asset management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://graphql\\.(us|eu)\\.jupiterone\\.io/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Bearer",
      },
      {
        name: "Jupiterone-Account",
        value: app.config.accountId,
      },
    ]),
  steps: [
    {
      title: "Get your API token and account ID",
      items: [
        {
          kind: "markdown",
          content:
            "In the JupiterOne console, go to **Settings → Admin → Account API Tokens** to create a token. Your account ID is listed under **Settings → Account Management**.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "Account ID",
          required: true,
          target: { kind: "configuration", field: "accountId" },
          helperText: "Your JupiterOne account ID.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ accountId }) => ({
      url: "https://graphql.us.jupiterone.io",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Jupiterone-Account": accountId ?? "",
      },
      body: JSON.stringify({
        query: `query { queryV1(query: "FIND Person LIMIT 1") { type } }`,
      }),
    }),
  },
});
